import { IcoClose } from '@icons';
import { SonarLogoSmall } from '@loghi/index';
import React from 'react';
import { Button, Modal } from 'react-bootstrap';
import { useHistory, useLocation } from 'react-router-dom';

interface NewBrandProps {}

const NewBrand: React.FC<NewBrandProps> = () => {
	const location = useLocation();
	const history = useHistory();
	const isModalOpen = location.hash === '#new-brand';
	const onHide = () => {
		history.push(location.pathname);
	};
	return (
		<>
			<Button
				onClick={() => {
					history.push('#new-brand');
				}}
				className="btn custom-ghost-button"
				style={{
					color: '#666666',
					textTransform: 'none',
					fontWeight: 400,
					textDecoration: 'underline',
				}}
			>
				Benvenuto in Sonar
			</Button>
			{/* <div
			style={{
				backgroundColor: 'var(--np-background-color)',
				padding: '2rem',
				display: 'grid',
				placeItems: 'center',
			}}
		>
			<div
				style={{
					borderRadius: '12px',
					maxWidth: '848px',
					margin: '0 auto',
					backgroundColor: '#fff',
					padding: '1.5rem',
					display: 'grid',
					gap: '3rem',
				}}
			> */}

			<Modal show={isModalOpen} onHide={onHide} fullscreen>
				<Modal.Header
					style={{
						padding: '3rem',
						justifyContent: 'flex-end',
					}}
				>
					<Button
						className="btn custom-ghost-button"
						onClick={onHide}
						style={{
							// color: '#06797F',
							display: 'flex',
							alignItems: 'center',
							gap: '0.75rem',
						}}
					>
						Chiudi
						<IcoClose
						// style={{
						// 	fill: '#06797F',
						// }}
						/>
					</Button>
				</Modal.Header>
				<Modal.Body
					style={{
						padding: '3rem',
						paddingTop: 0,
					}}
				>
					<div
						style={{
							maxWidth: '848px',
							margin: '0 auto',
							backgroundColor: '#fff',
							borderRadius: '12px',
							padding: '1.5rem',
							display: 'grid',
							gap: '2rem',
						}}
					>
						<h1
							style={{
								fontSize: '32px',
								fontWeight: 700,
								marginBottom: '1rem',
							}}
						>
							Benvenuti in Sonar: nuova identità, stessa missione.
						</h1>
						<div
							style={{
								backgroundColor: 'var(--np-text-primary-color)',
								margin: '0 auto',
								width: 'fit-content',
								padding: '1.5rem',
								borderRadius: '2px',
							}}
						>
							<SonarLogoSmall
								style={{
									fill: '#fff',
									width: '137px',
									height: '30px',
								}}
							/>
						</div>

						<div>
							<p>
								Sonar è l'evoluzione di OpenRep: una piattaforma sempre più completa, integrata, efficace ed efficiente per valorizzare
								l'uso dei fondi pubblici come strumento di crescita.
							</p>

							<h2
								style={{
									fontSize: '24px',
									textTransform: 'none',
									marginBottom: '1rem',
									fontWeight: 700,
								}}
							>
								Perché abbiamo cambiato nome?
							</h2>
							<p>
								La piattaforma è utilizzata da molti anni, con un track record di oltre 200 grandi progetti complessi rendicontati, da
								grandi aziende che operano soprattutto in ambito energetico e infrastrutturale. Forti di questa esperienza, abbiamo ideato
								un roadmap ancora più ambiziosa, che prevede nuove funzionalità e una nuova user experience. Abbiamo sentito la necessità di
								innovare anche l'identità complessiva della piattaforma.
							</p>
							<h2
								style={{
									fontSize: '24px',
									textTransform: 'none',
									marginBottom: '1rem',
									fontWeight: 700,
								}}
							>
								Perché «Sonar»?
							</h2>
							<p>
								Il nuovo nome vuole esprime meglio lo spirito evolutivo della piattaforma, da strumento di rendicontazione a vero e proprio
								sistema specializzato nella governance complessiva dei fondi pubblici. L'obiettivo? Aiutare enti pubblici e aziende private
								a orientarsi nella complessità dei fondi pubblici, a intercettare rischi e opportunità, a navigare con sicurezza verso
								obiettivi di crescita, impatto e adattamento grazie alla leva della finanza agevolata.
							</p>
							<h2
								style={{
									fontSize: '24px',
									textTransform: 'none',
									marginBottom: '1rem',
									fontWeight: 700,
								}}
							>
								Cosa cambia per te?
							</h2>

							<p>
								Tutti i tuoi dati e progetti restano invariati. L'interfaccia è stata adattata alla nuova identità (nuovo logo, nuovi
								colori) ma molti altri aggiornamenti sono in arrivo nei prossimi mesi.
							</p>
							<h2
								style={{
									fontSize: '24px',
									textTransform: 'none',
									marginBottom: '1rem',
									fontWeight: 700,
								}}
							>
								Dove restare aggiornato sulle novità?
							</h2>
							<p>
								Puoi semprefare riferimento al blog di OpenEconomics. Per comunicazioni di servizio più particolari o puntuali, non
								esiteremo a contattarti.
							</p>
						</div>
					</div>
				</Modal.Body>
			</Modal>

			{/* </div>
		</div> */}
		</>
	);
};

export default NewBrand;
